<template>
  <div v-if="cart.length > 0">
    <div>
      <v-row justify="center" class="mx-xl-6 mx-lg-6 mx-md-6" no-gutters>
        <v-col xl="9" lg="11" md="12" sm="12" cols="12">
          <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pb-xl-12 pb-lg-12 pb-md-8 pb-sm-4 pb-4" no-gutters>
            <v-col class="pr-xl-3 pr-lg-3 pr-md-3" xl="8" lg="8" md="8" sm="12" cols="12">
              <v-card class="mx-auto" outlined>
                <v-toolbar flat dense color="#F9F9F9">
                  <v-toolbar-title class="section-title px-2">Envío</v-toolbar-title>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text class="text-left py-0 px-0">
                  <delivery-address @notificationPopup="notificationPopup"></delivery-address>
                </v-card-text>
                <v-divider></v-divider>

                <v-toolbar flat dense color="#F9F9F9" class="card-border-bottom" v-if="totalFormulatedProducts > 0">
                  <v-toolbar-title class="section-title px-2">Fórmulas</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="text-left pt-xl-5 pt-lg-5 pt-md-5 pb-xl-6 pb-lg-6 pb-md-6 px-2 py-sm-0 py-0" v-if="totalFormulatedProducts > 0">
                  <div v-if="$vuetify.breakpoint.mdAndUp">
                    <div class="pb-2 px-4 grey--text text--darken-3">
                      Tienes productos formulados en el carrito, por favor carga las fórmulas
                    </div>
                    <formula-upload-form ref="formulaupload"></formula-upload-form>
                  </div>
                  <div v-else>
                    <v-list-item class="text-left" flat @click="uploadFormula">
                      <v-list-item-content>
                        <v-list-item-title class="subtitle-2 pb-0">
                          Cargar fórmula
                        </v-list-item-title>
                        <v-list-item-subtitle  class="subtitle-2" v-if="chosenFilesValid">
                          <div v-if="chosenFiles && chosenFiles.length > 0">
                            {{ chosenFiles.length }}
                            <span v-if="chosenFiles.length > 1">fórmulas cargadas</span>
                            <span v-else>fórmula cargada</span>
                          </div>
                          <div v-else>
                            Enviare despues mi fórmula
                          </div>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle  class="subtitle-2" v-else>
                          Hay productos formulados en el carrito
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn class="mr-n10" icon>
                          <v-icon color="blue">chevron_right</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </div>
                </v-card-text>

                <v-divider></v-divider>
                <v-toolbar flat dense color="#F9F9F9">
                  <v-toolbar-title class="section-title px-2">Artículos en el carrito</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="py-0 px-0">
                  <list-image-item-container class="card-border-top" v-for="(product, index) in cart" :key="'product_card' + index">
                    <template v-slot:image>
                      <div class="product-image-container mx-xl-2 mx-lg-2 mx-md-2 mx-sm-2 mx-1" @click="goToProductDetail(product.slug)">
                        <v-img class="product-image" :src="getProductCoverImage(index)" aspect-ratio="1"></v-img>
                      </div>
                    </template>
                    <template v-slot:content>
                      <div class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-1 pt-2">
                        <div class="text--primary text-left font-weight-light text-lowercase product-title first-capital-letter mt-1">
                          {{product.name}}
                          <span v-if="!!product.variant">&nbsp;({{product.variant.name}})</span>
                        </div>
                        <div class="headline label-price text-left font-weight-medium mt-1">{{ getProductPrice(index) }}</div>
                        <div class="text-left product-subtitle body-2 grey--text text--darken-1 mt-xl-1 mt-lg-1 mt-md-1 mt-sm-1">{{ product.brand }}</div>
                        <div class="text-left caption pt-1" v-if="product.formula">
                          <span v-for="(formula, index) in product.formula" :key="'product_formula_' + index">
                            <span>{{ getFormulaItemName(formula.name) }}:</span>
                            <span class="grey--text text--darken-2">&nbsp;{{ formula.value }} </span>
                          </span>
                        </div>
                      </div>
                      <div class="mt-xl-2 mt-lg-2 mt-md-2 mt-sm-2 mt-1 mb-xl-3 mb-lg-3 mb-md-3 mb-sm-1 mb-1">
                        <v-row no-gutters>
                          <v-col class="select-quantity">
                            <v-select
                              v-model="product.quantity"
                              :items="getProductQuantities(index)"
                              @change="setQuantity($event, index)"
                              filled
                              dense
                              hide-details>
                            </v-select>
                          </v-col>
                          <v-col class="text-left ml-5 pt-3">
                            <a class="blue--text" @click="confirmation(index)">Quitar</a>
                          </v-col>
                        </v-row>
                      </div>
                    </template>
                  </list-image-item-container>
                  <confirmation-modal ref="confirmation" title="¿Seguro(a)?" description="¿Quieres quitar el producto del carrito?" @confirmAction="remove"></confirmation-modal>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="pl-xl-3 pl-lg-3 pl-md-3" xl="4" lg="4" md="4" sm="12" cols="12">
              <v-card class="mx-auto" outlined>
                <v-toolbar flat dense color="#F9F9F9">
                  <v-toolbar-title class="section-title">Resumen del pedido</v-toolbar-title>
                </v-toolbar>
                <v-divider></v-divider>

                <v-card-text class="text-left px-0">
                  <v-row no-gutters class="px-4 pt-1 pb-1">
                    <v-col>
                      Total del producto
                    </v-col>
                    <v-col class="text-right grey--text text--darken-3">
                      {{ currency(totalCost) }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="px-4 pb-1">
                    <v-col>
                      Envío
                    </v-col>
                    <v-col class="text-right grey--text text--darken-3">
                      <span v-if="!!deliveryType && deliveryType.cost > 0">{{ currency(deliveryType.cost) }}</span>
                      <span v-else>-</span>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="px-4 pb-3 font-weight-bold">
                    <v-col>
                      Total del pedido
                    </v-col>
                    <v-col class="text-right grey--text text--darken-3">
                      {{ currency(totalPurchase) }}
                    </v-col>
                  </v-row>
                  <v-divider class="mt-3"></v-divider>

                  <v-row no-gutters class="px-4 pt-4">
                    <v-col cols="12" class="pt- pb-4">
                      <div class="caption grey--text text--darken-1">
                        Al hacer tu pedido, estás de acuerdo con las
                        <a class="blue--text link" @click="goToNewTab('Terms-and-conditions')">Condiciones de uso</a> y
                        <a class="blue--text link" @click="goToNewTab('Privacy-policies')">Política de privacidad</a>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <v-btn class="text-none" block height="42" color="blue darken-1" elevation="0" :loading="loading" dark @click="buy">
                        Realizar el pedido
                      </v-btn>
                    </v-col>
                    <v-col cols="12" class="pt-4 pb-1">
                      <div class="caption grey--text text--darken-1">
                        <a class="blue--text link" @click="goToNewTab('Terms-and-conditions')">Garantía del sitio hasta {{ daysWarranty }} dias</a>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <formula-upload-modal ref="formulauploadmodal" @formulaUploaded="formulaUploaded" v-if="$vuetify.breakpoint.smAndDown"></formula-upload-modal>
    </div>
  </div>
  <v-row class="py-8" justify="center" align="center" no-gutters v-else>
    <v-col cols="10">
      <v-icon size="150" color="grey" v-if="$vuetify.breakpoint.mdAndUp">shopping_cart</v-icon>
      <v-icon class="mb-2" size="100" color="grey" v-else>shopping_cart</v-icon>
      <div class="headline font-weight-regular mb-xl-5 mb-lg-5 mb-md-5 mb-sm-4 mb-4 not-found-title">Tu carrito está vacío.</div>
      <div class="mb-xl-1 mb-lg-1 mb-md-1">
        <v-btn class="text-none" color="blue darken-" dark large outlined @click="goToRouteByName('Home')">
          <v-icon left>store</v-icon>Continuar comprando
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import { currency } from '@/shared/format'
import { getFormulaItemName } from '@/shared/formula'
import { CASH_ON_DELIVERY_TYPE } from '@/shared/delivery'
import { getErrorMessage } from '@/shared/errors'
import { DAYS_WARRANTY } from '@/config/local-info'

import ListImageItemContainer from '@/components/List/ListImageItemContainer'
import ConfirmationModal from '@/components/Shared/ConfirmationModal'
import DeliveryAddress from '@/components/Checkout/DeliveryAddress'
import FormulaUploadForm from '@/components/Formula/FormulaUploadForm'
import FormulaUploadModal from '@/components/Formula/FormulaUploadModal'

export default {
  name: 'Cart',
  mixins: [navigationMixin],
  components: {
    ListImageItemContainer,
    ConfirmationModal,
    DeliveryAddress,
    FormulaUploadForm,
    FormulaUploadModal
  },
  data () {
    return {
      currency,
      getFormulaItemName,
      daysWarranty: DAYS_WARRANTY,
      chosenFiles: null,
      chosenFilesValid: false
    }
  },
  computed: {
    ...mapState('shared', ['error', 'loading']),
    ...mapState('cart', ['cart', 'user', 'deliveryAddress', 'deliveryType']),
    ...mapGetters('cart', ['getProductCoverImage', 'getProductPrice', 'getProductQuantities', 'totalFormulatedProducts', 'totalCost']),
    totalPurchase () {
      return this.totalCost + (this.deliveryType ? this.deliveryType.cost : 0)
    }
  },
  methods: {
    ...mapMutations('cart', ['removeProduct', 'changeQuantity']),
    ...mapMutations('cart', ['cleanShoppingCart']),
    ...mapActions('order', ['createOrder']),
    setQuantity (value, index) {
      if (value === 0) {
        this.confirmation()
        return
      }

      const data = { index: index, quantity: value }
      this.changeQuantity(data)
    },
    confirmation (index) {
      this.$refs.confirmation.openModal(index)
    },
    remove (index) {
      this.removeProduct(index)
    },
    goToProductDetail (slug) {
      this.goToRouteByName('Product-detail', { slug })
    },
    notificationPopup (data) {
      this.$emit('notificationPopup', data)
    },
    async buy () {
      if (!this.validate()) {
        return
      }

      const order = {
        products: this.cart,
        user: this.user,
        address: this.deliveryAddress,
        delivery: this.deliveryType
      }

      const result = await this.createOrder(order)
      if (this.error) {
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: getErrorMessage('checkout', this.error) })
        return
      }

      if (result.delivery.delivery_type === CASH_ON_DELIVERY_TYPE) {
        this.$emit('notificationPopup', { icon: 'shopping_bag', color: 'success', message: 'Su compra se ha completado con éxito y se enviará en breve' })
        this.cleanShoppingCart()
        this.goToRouteByName('Order', { id: result.order_id })
        return
      }

      // // eslint-disable-next-line
      // fbq('track', 'InitiateCheckout')
      // // eslint-disable-next-line
      // fbq('track', 'Order', { value: this.totalPurchase, currency: 'COP' })
      this.cleanShoppingCart()
      window.location.href = result.payment_url
    },
    validate () {
      if (!this.deliveryAddress) {
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: 'Por favor ingresa la dirección' })
        return false
      }

      if (!this.deliveryType) {
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: 'Por favor seleccione el tipo de entrega' })
        return false
      }

      if (!this.user) {
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: 'Por favor ingrese los datos del usuario' })
        return false
      }

      if (this.totalFormulatedProducts > 0) {
        if (this.$vuetify.breakpoint.smAndDown) {
          return this.validateFilesOnMobile()
        }

        return this.validateFiles()
      }

      return true
    },
    validateFiles () {
      const formulaData = this.$refs.formulaupload.validate()
      this.chosenFiles = formulaData.chosenFiles

      return formulaData.valid
    },
    validateFilesOnMobile () {
      if (!this.chosenFilesValid) {
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: 'Por favor cargue las fórmulas' })
      }

      return this.chosenFilesValid
    },
    uploadFormula () {
      this.$refs.formulauploadmodal.openModal()
    },
    formulaUploaded (chosenFiles) {
      this.chosenFilesValid = true
      this.chosenFiles = chosenFiles
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';
  .product-image {
    width: 10rem;
    height: 10rem;
    border-radius: 0.25rem;
  }
  .product-image-container {
    cursor: pointer;
    position: relative;
    width: 10rem;
    height: 10rem;
    border-radius: 0.25rem;
  }
  .product-title{
    font-size: 1.25em;
  }
  .select-quantity{
    max-width: 100px;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .not-found-title{
      font-size: 16px !important;
      line-height: 24px;
    }
    .product-image {
      width: 6.875rem;
      height: 6.875rem;
    }
    .product-image-container {
      position: relative;
      width: 6.875rem;
      height: 6.875rem;
    }
    .product-title{
      font-size: 1.063rem;
      line-height: 1.125rem;
    }
    .product-subtitle{
      font-size: 0.813rem !important;
      line-height: 1rem;
    }
    .label-price{
      font-size: 1.375rem !important;
    }
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    .product-title{
      font-size: 0.938rem;
    }
  }
</style>
